import React from 'react';
import clsx from 'clsx';

export default function AppButtonFooter({
  children,
  onClick,
  width = 'w-16',
  roundedFull = 'rounded-full', // full Tailwind class
  className = '',
  ...props
}) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'flex items-center justify-center gap-1 p-2 text-onSecondaryContainer hover:bg-secondary hover:text-onSecondary transition text-sm bg-secondaryContainer',        width,
        roundedFull,
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
